
// wishlist > add cart
document.addEventListener("DOMContentLoaded", () => {
  const body = document.body;
  if (!body) return;

  const MINI_CART_SECTION_ID = "mini-cart"; // must match: event.detail.cart.sections["mini-cart"]

  async function getCartJson() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed to fetch /cart.js");
    return res.json();
  }

  async function getMiniCartSectionHtml() {
    // Your theme uses: `${routes.cartUrl}?section_id=${this.getAttribute("section")}`
    // Your <cart-drawer section="mini-cart" ...>
    const cartUrl = window.themeVariables?.routes?.cartUrl || "/cart";
    const url = `${cartUrl}?section_id=${MINI_CART_SECTION_ID}`;

    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) throw new Error(`Failed to fetch section HTML: ${url}`);
    return res.text();
  }

  function extractCartDrawerInnerFromSectionHtml(sectionHtml) {
    const fakeDiv = document.createElement("div");
    fakeDiv.innerHTML = sectionHtml;

    const drawer = fakeDiv.querySelector("cart-drawer");
    // Theme does: fakeDiv.querySelector("cart-drawer").innerHTML
    // so we must provide the WHOLE drawer html under sections["mini-cart"]
    return drawer ? drawer.outerHTML : sectionHtml;
  }

  function dispatchToRootDelegates(eventName, detail) {
    const evt = new CustomEvent(eventName, { bubbles: true, detail });

    // Some themes delegate off document, others off <html> or a root element
    document.dispatchEvent(evt);
    document.documentElement.dispatchEvent(
      new CustomEvent(eventName, { bubbles: true, detail })
    );
  }

  body.addEventListener("wishlistAddToCartEvent", async (e) => {
    try {
      // Give the wishlist app time to finish its add-to-cart AJAX
      await new Promise((r) => setTimeout(r, 150));

      // Build the payload the theme understands
      const [cart, sectionHtml] = await Promise.all([getCartJson(), getMiniCartSectionHtml()]);
      const drawerHtml = extractCartDrawerInnerFromSectionHtml(sectionHtml);

      const cartForTheme = {
        ...cart,
        sections: {
          [MINI_CART_SECTION_ID]: drawerHtml, // theme reads ["mini-cart"]
        },
      };

      dispatchToRootDelegates("cart:refresh", {
        cart: cartForTheme,
        openMiniCart: true,          // THIS is what opens it
        replacementDelay: 0,         // optional: render immediately
        source: "wishlist",
        productId: e.detail?.productId ?? null,
        variantId: e.detail?.variantId ?? null,
      });

      // Optional: update count listeners too (some themes update badges on refresh already)
      dispatchToRootDelegates("cart:updated", {
        cart: cartForTheme,
        source: "wishlist",
      });
    } catch (err) {
      console.error("[wishlist->mini-cart] failed", err);
    }
  });
});

// wishlist page format price
function formatPriceText(elements) {
  elements.forEach(function (element) {
    if (element.dataset.processed === "true") return;

    // Extract numeric value only (handles 105.00, 140, etc)
    const match = element.textContent.match(/([\d,.]+)/);
    if (!match) return;

    const value = parseFloat(match[1].replace(',', ''));

    // Format as $140 (no decimals)
    element.textContent = `$${Math.round(value)}`;

    element.dataset.processed = "true";
  });
}

const observer = new MutationObserver(() => {
  const elements = document.querySelectorAll(
    '.ucwl-osc-css .product-price:not([data-processed])'
  );
  formatPriceText(elements);
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
